// client: recordati
// env: production
// branch: staging-recordati

export const environment = {
  // client name
  client: 'recordati',
  // is this a production environment?
  production: true,
  // api url
  apiUrl: 'https://api.recordati-aspire.ffi-ventures.com',
  // !UNUSED? list of support PDF files in the form of { name: string, path: string }[]
  supportPdfs: [],
  // show KAM reports
  reportsShowKamReports: true,
  // enable cache
  enableCache: true
};
